// Case Resolution System Types

export enum CaseStatus {
  UNREAD = 'UNREAD',
  READ = 'READ',
  IN_PROGRESS = 'IN_PROGRESS',
  RESOLVED = 'RESOLVED'
}

export enum AdminActionType {
  COMPLETE_TRADE = 'COMPLETE_TRADE',
  CANCEL_TRADE = 'CANCEL_TRADE',
  REFUND_BOTH = 'REFUND_BOTH',
  NO_ACTION = 'NO_ACTION',
  SET_DUE_DATE = 'SET_DUE_DATE',
  MESSAGE_SENT = 'MESSAGE_SENT',
  CASE_REOPENED = 'CASE_REOPENED'
}

export interface Case {
  id: string;
  tradeId: string;
  conversationId: string;
  status: CaseStatus;
  createdAt: string;
  updatedAt: string;
  dueDate: string | null;
  summonedBy: number;
  alsoRequestedBy: number | null;
  senderUsername: string;
  receiverUsername: string;
  tradeNumber: string;
  trade?: {
    createdAt: string;
    sender?: {
      id: number;
      username: string;
      avatarUrl?: string;
    };
    receiver?: {
      id: number;
      username: string;
      avatarUrl?: string;
    };
  };
}

export interface CaseListResponse {
  cases: Case[];
  pagination: {
    currentPage: number;
    totalPages: number;
    totalCases: number;
    pageSize: number;
  };
}

export interface CaseMessage {
  id: string;
  content: string;
  senderId: number;
  senderUsername: string;
  receiverId: number;
  createdAt: string;
  readAt: string | null;
  sender: {
    id: number;
    username: string;
    avatarUrl?: string;
    isAdminMessage: boolean;
  };
}

export interface AdminAction {
  id: string;
  caseId: string;
  adminId: number | null;
  adminUsername: string | null;
  actionType: AdminActionType;
  details: Record<string, any> | null;
  createdAt: string;
}

export interface TradeDetails {
  id: string;
  status: string;
  tradeNumber: string;
  createdAt: string;
  totalValue: number;
  sender: {
    id: number;
    username: string;
    email?: string;
    avatarUrl?: string;
  };
  receiver: {
    id: number;
    username: string;
    email?: string;
    avatarUrl?: string;
  };
  items: Array<{
    id?: string;
    name: string;
    setCode?: string;
    setName?: string;
    set?: string;
    quantity: number;
    condition: string;
    pointValue: number;
    foil?: boolean;
    language?: string;
    edition?: string;
    scryfallID?: string;
    collectorNumber?: string;
    rarity?: string;
  }>;
}

export interface CaseDetailResponse {
  case: Case & {
    trade: TradeDetails;
  };
  messages: CaseMessage[];
  adminActions: AdminAction[];
  dividerTimestamp: string;
  conversationId: string;
}

export interface TradeCaseStatusResponse {
  exists: boolean;
  case?: {
    id: string;
    status: CaseStatus;
    createdAt: string;
    dueDate: string | null;
  };
  summonedBy?: string;
  alsoRequestedBy?: string | null;
  summonedAt?: string;
}

export interface SummonAdminResponse {
  caseId: string;
  status: CaseStatus;
  message: string;
  conversationId: string;
}

export interface CaseBadgeCountResponse {
  unreadCount: number;
}

export interface AdminActionRequest {
  actionType: AdminActionType;
  details?: {
    dueDate?: string;
    notes?: string;
  };
}

export interface AdminActionResponse {
  success: boolean;
  case: {
    id: string;
    status: CaseStatus;
    updatedAt: string;
  };
}

export interface SendAdminMessageRequest {
  content: string;
}

export interface SendAdminMessageResponse {
  success: boolean;
}

export interface SetDueDateRequest {
  dueDate: string;
}

export interface SetDueDateResponse {
  success: boolean;
  case: {
    id: string;
    dueDate: string;
    status: CaseStatus;
  };
}
